import { render, staticRenderFns } from "./UserCashInfoHistory.vue?vue&type=template&id=16babb00&lang=html"
import script from "./UserCashInfoHistory.vue?vue&type=script&lang=js"
export * from "./UserCashInfoHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports